import { render, staticRenderFns } from "./Foot.vue?vue&type=template&id=24d25cc4&scoped=true&"
import script from "./Foot.vue?vue&type=script&lang=js&"
export * from "./Foot.vue?vue&type=script&lang=js&"
import style0 from "./Foot.vue?vue&type=style&index=0&id=24d25cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d25cc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d25cc4')) {
      api.createRecord('24d25cc4', component.options)
    } else {
      api.reload('24d25cc4', component.options)
    }
    module.hot.accept("./Foot.vue?vue&type=template&id=24d25cc4&scoped=true&", function () {
      api.rerender('24d25cc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Foot.vue"
export default component.exports